import styled from '@emotion/styled'
import React, { type FunctionComponent } from 'react'

interface AttributeOverridesTableExpiryDateCellProps {
  expiryDate: string
}

const StyledContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

export const AttributeOverridesTableExpiryDateCell: FunctionComponent<
  AttributeOverridesTableExpiryDateCellProps
> = ({ expiryDate }) => <StyledContainer>{expiryDate}</StyledContainer>
